import { Injectable } from '@angular/core';
import { CommonService } from './common.service';


@Injectable({
  providedIn: 'root'
})
export class DmsCallService {

  constructor(private commonService: CommonService) { }

  get WindowRef() {
    return window;
  }
  // ************************************************************************************************************************
  //                                          Dealer Management System (Master)
  // ************************************************************************************************************************
  getHomeData = (data: any) => this.commonService.doGet('CompanyInfo' + '/' + data.head.companyName, data)
  sendForgetPass = (data:any) => this.commonService.doPut('Users'+ '/'+ 'ResetPassword'+'/'+ data.head.Userid,data)
  getCompany = (data: any) => this.commonService.doGet('Company', data);
  addCompany = (data: any) => this.commonService.doPost('Company', data);
  updateCompany = (data: any) => this.commonService.doPut('Company' + '/' + data.head.compCode, data);
  deleteCompany = (data: any) => this.commonService.doDelete('Company', data);

  getPlant = (data: any) => this.commonService.doGet('Plant', data);
  addPlant = (data: any) => this.commonService.doPost('Plant', data);
  updatePlant = (data: any) => this.commonService.doPost('Plant', data);
  deletePlant = (data: any) => this.commonService.doDelete('Plant', data);


  getCountry = (data: any) => this.commonService.doGet('Countries', data);

  getStatesNo = (data: any) => this.commonService.doGet('states', data);
  getStates = (data: any) => this.commonService.doGet('States' + '/' + data.head.CountryID, data);
  getRegions = (data: any) => this.commonService.doGet('Region' + '/' + "Country" + '/' + data.head.CountryID, data);

  // ************************************************************************************************************************
  //                                          Dealer Management System
  // ************************************************************************************************************************
  getaccountGroups = (data: any) => this.commonService.doGet('AccountGroup', data);
  getRole = (data: any) => this.commonService.doGet('role', data);

  getProductGroups = (data: any) => this.commonService.doGet('ProductGroup', data);
  addProductGroups = (data: any) => this.commonService.doPost('ProductGroup', data);
  updateProductGroups = (data: any) => this.commonService.doPut('ProductGroup' + '/' + data.head.ID, data);
  deleteProductGroups = (data: any) => this.commonService.doDelete('ProductGroup' + '/' + data.head.ID, data);

  getDocumentType = (data: any) => this.commonService.doGet('Documents' + '/' + 'DocumentType', data);
  getLogin = (data: any) => this.commonService.doGet('login', data);

  getUser = (data: any) => this.commonService.doGet('users', data);
  getSingleUser = (data: any) => this.commonService.doGet('users' + '/' + data.head.Userid, data);
  AddUser = (data: any) => this.commonService.doPost('users', data);
  UpdateUser = (data: any) => this.commonService.doPut('users' + '/' + data.head.UserID, data);



  getLabelPrintUser = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'LabelUser', data);
  // getUserSupplier = (data: any) => this.commonService.doGet('UserSupplierAssignment', data);
  getSingleUserSupplier = (data: any) => this.commonService.doGet('UserSupplierAssignment' + '/' + data.head.UBPCode, data);
  AddUserSupplier = (data: any) => this.commonService.doPost('UserSupplierAssignment', data);
  UpdateUserSupplier = (data: any) => this.commonService.doPut('UserSupplierAssignment', data);


  getGuest = (data: any) => this.commonService.doGet('Guest', data);
  getGuestLog = (data: any) => this.commonService.doGet('GuestLog', data);

  getDealer = (data: any) => this.commonService.doGet('Dealer', data);
  AllDealers = (data: any) => this.commonService.doGet('Dealer' + '/' + 'AllDealers', data);
  AddDealer = (data: any) => this.commonService.doPost('Dealer', data);
  UpdateDealer = (data: any) => this.commonService.doPut('Dealer' + '/' + data.head.ID, data);
  DeleteCustomer = (data: any) => this.commonService.doDelete('Dealer' + '/' + data.head.ID, data);
  getAssignDealers = (data: any) => this.commonService.doGet('Dealer' + '/' + data.head.CountryID + '/' + data.head.StateID, data);
  getDealerStatewise = (data: any) => this.commonService.doPost('Dealer' + '/' + 'DealerStatewise', data);

  getBusinessPatner = (data: any) => this.commonService.doGet('BusinessPatner', data);
  addBusinessPatner = (data: any) => this.commonService.doPost('BusinessPatner', data);
  updateBusinessPatner = (data: any) => this.commonService.doPut('BusinessPatner' + '/' + data.head.ID, data);
  deleteBusinessPatner = (data: any) => this.commonService.doDelete('BusinessPatner' + '/' + data.head.ID, data);

  getAssigneSegmentDealer = (data: any) => this.commonService.doGetBlob('AssigneSegmentDealer', data);
  AssigneSegmentDealer = (data: any) => this.commonService.doPost('AssigneSegmentDealer', data);

  getEmployee = (data: any) => this.commonService.doGet('Employee', data);
  addEmployee = (data: any) => this.commonService.doPost('Employee', data);
  updateEmployee = (data: any) => this.commonService.doPut('Employee' + '/' + data.head.BPID, data);

  getSenior = (data: any) => this.commonService.doGet('Employee' + '/' + 'GetSenior' + '/' + data.head.desigID, data);

  getDesignations = (data: any) => this.commonService.doGet('Designations', data);

  getProductMaster = (data: any) => this.commonService.doGet('ProductMaster', data);
  getProductMasterProduct = (data: any) => this.commonService.doGet('ProductMaster' + '/' + 'Product', data);
  getProductMasterlabel = (data: any) => this.commonService.doGet('ProductMaster' + '/' + 'label', data);
  getSingleProductMaster = (data: any) => this.commonService.doGet('ProductMaster' + '/' + data.head.BPCode, data);
  addProductMaster = (data: any) => this.commonService.doPost('ProductMaster', data);
  bulkProductMaster = (data: any) => this.commonService.doPost('ProductMaster' + '/' + 'BulkUpload', data);
  updateProductMaster = (data: any) => this.commonService.doPut('ProductMaster' + '/' + data.head.ProductID, data);
  deleteProductMaster = (data: any) => this.commonService.doDelete('ProductMaster' + '/' + data.head.ProductID, data);

  getBrandMaster = (data: any) => this.commonService.doGet('BrandMaster', data);
  addBrandMaster = (data: any) => this.commonService.doPost('BrandMaster', data);
  updateBrandMaster = (data: any) => this.commonService.doPut('BrandMaster' + '/' + data.head.ID, data);
  deleteBrandMaster = (data: any) => this.commonService.doDelete('BrandMaster' + '/' + data.head.ID, data);

  getOrder = (data: any) => this.commonService.doGet('Order' + '/' + data.head.Open, data);
  createOrder = (data: any) => this.commonService.doPost('Order', data);
  UpdateOrder = (data: any) => this.commonService.doPut('Order' + '/' + data.head.OrderId, data);
  ApproveRejectedOrders = (data: any) => this.commonService.doPut('Order' + '/' + 'ChangeStatus', data);
  UpdateDeportOrders = (data: any) => this.commonService.doPut('Order' + '/' + 'ChangeDepot', data);


  getCommunication = (data: any) => this.commonService.doGet('Documents', data);
  addCommunications = (data: any) => this.commonService.doPost('Documents', data);
  delCommunication = (data: any) => this.commonService.doDelete('Documents' + '/' + data.head.ID, data);
  putCommunication = (data: any) => this.commonService.doPut('Documents', data);
  getOutstanding = (data: any) => this.commonService.doGet('Outstanding', data);
  addOutstanding = (data: any) => this.commonService.doPost('Outstanding', data);

  getLedger = (data: any) => this.commonService.doGet('Ledger', data);
  addLedger = (data: any) => this.commonService.doPost('Ledger', data);

  GuestLogin = (data: any) => this.commonService.doPost('Guest', data);

  getManufacture = (data: any) => this.commonService.doGet('Manufacturer', data);
  AddManufacture = (data: any) => this.commonService.doPost('Manufacturer', data);
  UpdateManufacture = (data: any) => this.commonService.doPut('Manufacturer' + '/' + data.ID, data);
  DeleteManufacture = (data: any) => this.commonService.doDelete('Manufacturer' + '/' + data.ID, data);


  getApplication = (data: any) => this.commonService.doGet('Application', data);
  AddApplication = (data: any) => this.commonService.doPost('Application', data);
  UpdateApplication = (data: any) => this.commonService.doPut('Application' + '/' + data.ID, data);
  DeleteApplication = (data: any) => this.commonService.doDelete('Application' + '/' + data.ID, data);

  getApplicationToProduct = (data: any) => this.commonService.doGet('ApplicationToProduct', data);
  getApplicationToProductMfgApp = (data: any) => this.commonService.doGet('ApplicationToProduct' + '/' + 'MfgApp', data);
  AddApplicationToProduct = (data: any) => this.commonService.doPost('ApplicationToProduct', data);
  UpdateApplicationToProduct = (data: any) => this.commonService.doPut('ApplicationToProduct' + '/' + data.ID, data);
  BulkApplicationToProduct = (data: any) => this.commonService.doPost('ApplicationToProduct' + '/' + 'BulkUpload', data);

  getHsnGst = (data: any) => this.commonService.doGet('HsnGst', data);
  AddHsnGst = (data: any) => this.commonService.doPost('HsnGst', data);
  UpdateHsnGst = (data: any) => this.commonService.doPut('HsnGst', data);

  getPriceCondition = (data: any) => this.commonService.doGet('PriceCondition', data);
  AddPriceCondition = (data: any) => this.commonService.doPost('PriceCondition', data);
  UpdatePriceCondition = (data: any) => this.commonService.doPut('PriceCondition' + '/' + data.head.id, data);

  getPricingGroup = (data: any) => this.commonService.doGet('PricingGroup', data);

  getLabelMaster = (data: any) => this.commonService.doGet('LabelMaster', data);
  addLabelMaster = (data: any) => this.commonService.doPost('LabelMaster', data);
  updateLabelMaster = (data: any) => this.commonService.doPut('LabelMaster' + '/' + data.head.ID, data);
  deleteLabelMaster = (data: any) => this.commonService.doDelete('LabelMaster' + '/' + data.head.ID, data);

  getProductGroup = (data: any) => this.commonService.doGet('ProductGroup', data);
  ApplyFilter = (data: any) => this.commonService.doGet('ProductMaster/FilterProduct', data);
  getAllApplication = (data: any) => this.commonService.doGet('Application', data);
  getManufactureApplication = (data: any) => this.commonService.doGet('Application/' + data.param.ID, data);
  getApplicationProduuctGroup = (data: any) => this.commonService.doGet('ProductGroup/' + data.param.ID, data);
  GuestLogs = (data: any) => this.commonService.doPost('GuestLog', data);

  getContactShipTo = (data: any) => this.commonService.doGet('Contact_shipTo' + '/' + 'UnAssigne', data);


  // ************************************************************************************************************************
  //                                          Label Printing System
  // ************************************************************************************************************************
  // Label Print IAM Primary
  getLablePrint = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'IAMPrimary' + '/' + data.head.CompanyID + '/' + data.head.Plant, data);
  Addlabels = (data: any) => this.commonService.doPostAPI('labels' + '/' + 2.755907 + 'x' + 1.968505 + '/' + 0 + '/', data);
  // http://api.labelary.com/v1/printers/8dpmm/labels/2.755907x1.968505/0/
  // LabelPrint IAM Secondary
  getSecondaryLablePrint = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'IAMSecondary' + '/' + data.head.CompanyID, data);
  // SecondaryLables = (data: any) => this.commonService.doPostAPI('labels' + '/' + 1.968505 + 'x' + 2.755907 + '/' + 0 + '/', data);

  // Label Print IAM Invoice
  getInvoiceLablePrint = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'IAMInvoice' + '/' + data.head.CompanyID, data);

  // OES Master
  getOESCustomerMaster = (data: any) => this.commonService.doGet('OESCustomerMaster', data);
  addOESCustomerMaster = (data: any) => this.commonService.doPost('OESCustomerMaster', data);
  updateOESCustomerMaster = (data: any) => this.commonService.doPut('OESCustomerMaster' + '/' + data.head.customerCode, data);
  deleteOESCustomerMaster = (data: any) => this.commonService.doDelete('OESCustomerMaster' + '/' + data.head.customerCode, data);

  getOESPartMaster = (data: any) => this.commonService.doGet('OESProductsMaster', data);
  addOESPartMaster = (data: any) => this.commonService.doPost('OESProductsMaster', data);
  updateOESPartMaster = (data: any) => this.commonService.doPut('OESProductsMaster' + '/' + data.param.hitachiPartNumber, data);
  deleteOESPartMaster = (data: any) => this.commonService.doDelete('OESProductsMaster' + '/' + data.param.hitachiPartNumber, data);

  getOESCustomerMaterial = (data: any) => this.commonService.doGet('OESCustomerMaterial', data);
  addOESCustomerMaterial = (data: any) => this.commonService.doPost('OESCustomerMaterial', data);
  updateOESCustomerMaterial = (data: any) => this.commonService.doPut('OESCustomerMaterial' + '/' + data.head.customerMaterialNumber + '/' + data.head.customerCode + '/' + data.head.hitachiPartNumber, data);
  deleteOESCustomerMaterial = (data: any) => this.commonService.doDelete('OESCustomerMaterial' + '/' + data.head.customerMaterialNumber + '/' + data.head.customerCode + '/' + data.head.hitachiPartNumber, data);

  getOESMaterialCustomer = (data: any) => this.commonService.doGet('OESProductsMaster/GetCustomer' + '/' + data.head.HitachiPartNumber, data);

  // Label Print OES Primary
  getOESPrimaryLabelPrint = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'OESPrimary' + '/' + data.head.CompanyID, data);

  // Label Print OES Secondary
  getOESSecondaryLabelPrint = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'OESSecondary' + '/' + data.head.CompanyID, data);

  // Label Print OES Invoice
  getOESInvoiceLabelPrint = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'OESInvoice' + '/' + data.head.CompanyID, data);



  getPrinterList = () => this.commonService.doGetPrinter('PrinterService');
  printPrinterList = (data: any) => this.commonService.doPostPrinter('PrinterService', data);

  // Report Section
  getEmployeeDealerAssignment = (data: any) => this.commonService.doGet('reports' + '/' + 'EmployeeDealerAssignment', data);
  getEmployeeStateAssignment = (data: any) => this.commonService.doGet('reports' + '/' + 'EmployeeStateAssignment', data);

  getPrintLogs = (data: any) => this.commonService.doGet('printLog' , data);

  getStockTransferLabel = (data: any) => this.commonService.doGet('StockTransfer', data);
  addStockTransferLabel = (data: any) => this.commonService.doPost('StockTransfer', data);
  updateStockTransferLabel = (data: any) => this.commonService.doPut('StockTransfer' + '/' + data.head.PartID, data);
  deleteStockTransferLabel = (data: any) => this.commonService.doDelete('StockTransfer' + '/' + data.head.PartID, data);

  getLablePrintStPrimary = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'STPrimary' + '/' + data.head.CompanyID, data);
  getLablePrintSTInvoice = (data: any) => this.commonService.doGet('LabelPrint' + '/' + 'STInvoice' + '/' + data.head.CompanyID, data);
  // ************************************************************************************************************************
  //                                         / Dealer Management System
  // ************************************************************************************************************************

  postLedger = (data: any) => this.commonService.doPostFile('Ledger', data);; 


}